module.exports = __webpack_public_path__ + "28b67065/img/google.68f3823e.svg";